import type { FeatureCollection, Geometry, GeoJsonProperties } from "geojson";
import type { LngLatLike } from "../units";

export const MAX_PANEL_SIZE_X = 180;
export const MAX_PANEL_SIZE_Y = 180;
export const MIN_PANEL_SIZE_X = 50;
export const MIN_PANEL_SIZE_Y = 50;
export const MIN_PANEL_DEPTH = 3;
export const MAX_PANEL_DEPTH = 50;

export function bboxesFromLLUR(
    ll: LngLatLike,
    ur: LngLatLike,
    w: number,
    h: number,
): FeatureCollection {
    const [llx, urx] = [
        Math.min(ll.lng, ur.lng), //ul.lng, lr.lng),
        Math.max(ll.lng, ur.lng), //ul.lng, lr.lng),
    ];
    const [lly, ury] = [
        Math.min(ll.lat, ur.lat), //ul.lat, lr.lat),
        Math.max(ll.lat, ur.lat), //ul.lat, lr.lat),
    ];

    if (ll.lng != llx) ll.lng = llx;
    if (ll.lat != lly) ll.lat = lly;

    if (ur.lng != urx) ur.lng = urx;
    if (ur.lat != ury) ur.lat = ury;

    const xFragments = Math.ceil(w / MAX_PANEL_SIZE_X);
    const yFragments = Math.ceil(h / MAX_PANEL_SIZE_Y);

    let features: any[] = [];
    let xIntervals = xFragments;
    let x = llx;
    while (x <= urx && xIntervals > 0) {
        let ox = x;
        x += (urx - x) / xIntervals;
        xIntervals -= 1;
        let y = lly;
        let yIntervals = yFragments;
        while (y <= ury && yIntervals > 0) {
            let oy = y;
            y += (ury - y) / yIntervals;
            yIntervals -= 1;
            features.push({
                type: "Feature",
                properties: {},
                geometry: {
                    type: "Polygon",
                    coordinates: [
                        [
                            [ox, oy],
                            [ox, y],
                            [x, y],
                            [x, oy],
                            [ox, oy],
                        ],
                    ],
                },
            });
        }
    }
    const rv: FeatureCollection<Geometry, GeoJsonProperties> = {
        type: "FeatureCollection",
        features: features,
    };
    return rv;
}
